import styled, { css } from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import Link from '../Link'
import Picture from '../Picture'
import Icon from '../Icon'

export const Container = styled(Link)<{ $apectRatio?: number }>`
  position: relative;
  color: ${({ theme }) => theme.colors.black};
  overflow: hidden;
`
export const _Picture = styled(Picture)`
  transition: transform 0.3s ease-in-out;
  width: 100%;
  ${Container}:focus &,
  ${Container}:hover & {
    transform: scale(1.05);
  }
`
export const Label = styled.span<{ $color?: string; $noText?: boolean }>`
  ${({ theme }) => theme.textStyles.m375_h3}
  position: absolute;
  inset-block-end: 0;
  inset-inline-end: 0;
  display: flex;
  align-items: center;
  gap: ${pxToRem(16)};
  padding: ${pxToRem(16)};
  width: 95%;
  max-width: ${pxToRem(324)};
  background-color: ${({ theme }) => theme.colors.white};
  transition: background-color 0.3s ease-in-out;
  ${Container}:focus &,
  ${Container}:hover & {
    background-color: ${({ $color }) => $color};
  }
  ${({ $noText }) =>
    $noText === true &&
    css`
      width: auto;
      aspect-ratio: 1;
    `}
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h3}
    gap: ${pxToRem(24)};
    padding: ${pxToRem(24)};
  }
`
export const _Icon = styled(Icon)`
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(24)};
  transition: transform 0.3s ease-in-out;
  ${Container}:focus &,
  ${Container}:hover & {
    transform: translateX(${pxToRem(8)});
  }
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.d1440_body}
  @media ${mq(sizes.tablet)} {
  }
`
